import type { TFunction } from 'i18next';
import { HTTP_FORBIDDEN } from '../constants/httpStatusConstants';
import { getHttpStatus } from '../utils/errorMessageUtils';

export interface YearPlanErrorDialogContent {
  title?: string;
  message: string;
}

/**
 * Turns a failed year-plan operation (save/discard) into what the error dialog shows.
 *
 * A 403 means the user's permission on the location was revoked while they were
 * editing. "Please try again" is actively misleading there — retrying cannot
 * succeed — so that case gets its own title and an explanation of what to do.
 * Everything else keeps the generic, retryable wording the caller passes in.
 */
export const buildYearPlanErrorDialog = (
  error: unknown,
  t: TFunction,
  fallbackMessage: string
): YearPlanErrorDialogContent => {
  if (getHttpStatus(error) === HTTP_FORBIDDEN) {
    return {
      title: t('error-permission-denied-title'),
      message: t('error-permission-denied-message')
    };
  }
  return { message: fallbackMessage };
};
